import React from 'react'
import _ from 'underscore'
import { ActionExecution } from '../../domain/ActionExecution'
import moment from 'moment/moment'
import Link from '../../helper/link'
import { connect } from 'react-redux'

interface Props {
    actionExecutions?: ActionExecution[]
}

class NotificationLog extends React.Component<Props> {
    public render() {
        if (!this.props.actionExecutions || this.props.actionExecutions.length === 0) {
            return (
                <div className="box box-default" style={{ marginBottom: 0, paddingLeft: 10 }}>
                    <div className="box-body">
                        <p>No notifications have been sent for this event.</p>
                        <p>
                            To configure notifications click <Link route="XhprofAlertBundle.Configuration.list">here</Link>
                        </p>
                    </div>
                </div>
            )
        }

        return (
            <table className="table table-striped">
                <thead>
                    <tr>
                        <th>Date</th>
                        <th>Type</th>
                        <th>Name</th>
                        <th>Status</th>
                    </tr>
                </thead>
                <tbody>
                    {_.map(this.props.actionExecutions, (actionExecution, index) => {
                        return (
                            <tr key={index}>
                                <td>
                                    {moment
                                        .utc(actionExecution.executionTime)
                                        .local()
                                        .format('DD.MM.YY HH:mm')}
                                </td>
                                <td>{actionExecution.action.readableType}</td>
                                <td>{actionExecution.action.title}</td>
                                <td className="capitalize">{actionExecution.deliveryStatus}</td>
                            </tr>
                        )
                    })}
                </tbody>
            </table>
        )
    }
}

export default connect()(NotificationLog)
